// extracted by mini-css-extract-plugin
export default {"selectionRectangle":"SelectionLayer_selectionRectangle__dYIAX"};